import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const ContentCollectionSidebarSeparator = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("h-px w-full bg-grey-5", className),
        ...restOfProps
    });
};
